import { BlobProvider } from "@react-pdf/renderer";
import { useState } from "react";
import { AttendanceReport } from "./AttendanceReport";

export default function AttReportBtn({ btnClasses, selectedReport }) {
  /*   All States
   ********************************************* */
  const [showPdf, setShowPdf] = useState(false);

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */

  return (
    <>
      {showPdf ? (
        <>
          <BlobProvider
            document={<AttendanceReport selectedReport={selectedReport} />}
          >
            {({ url, blob }) => {
              const isDisabled = !showPdf || !blob;
              const userName = selectedReport?.userData?.name;
              const safeUserName = userName
                ? userName.replace(/[^a-zA-Z0-9]+/g, "-").replace(/^-+|-+$/g, "")
                : selectedReport?.userId || selectedReport?.month || "download";
              return (
                <span className="d-inline-flex gap-2">
                  <a
                    href={isDisabled ? "#" : url}
                    download={`Attendance-Report-${safeUserName}.pdf`}
                    className={btnClasses}
                    onClick={(e) => {
                      if (isDisabled) e.preventDefault();
                    }}
                  >
                    <i className="mdi mdi-download"></i>Download Report
                  </a>
                  <a
                    href={isDisabled ? "#" : url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={btnClasses}
                    onClick={(e) => {
                      if (isDisabled) e.preventDefault();
                    }}
                  >
                    <i className="mdi mdi-eye"></i>View Report
                    {!url && (
                      <div
                        className="spinner-border spinner-border-sm text-white ms-2 mb-1"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </a>
                </span>
              );
            }}
          </BlobProvider>
        </>
      ) : (
        <>
          <button
            className={btnClasses}
            onClick={(e) => {
              setShowPdf(true);
            }}
          >
            Generate Report
          </button>
        </>
      )}
    </>
  );
}
